import { render, staticRenderFns } from "./GrcDate.vue?vue&type=template&id=277fab5c&"
import script from "./GrcDate.vue?vue&type=script&lang=js&"
export * from "./GrcDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports